import { SELECTORS, CLASSES, BREAKPOINT } from '../config/constants';

export default function () {
  const navEl = document.querySelector(SELECTORS.NAV);

  if (!(navEl instanceof HTMLElement)) {
    return;
  }

  const isDesktop = window.matchMedia(`(min-width: ${BREAKPOINT.HAMBURGER_MENU}px)`);

  const callback = () => {
    const { top: navElPositionTop } = navEl.getBoundingClientRect();

    navEl.classList.toggle(CLASSES.STICKY_NAV, !navElPositionTop);
  };

  isDesktop.addEventListener('change', (e) => {
    if (isDesktop.matches) {
      window.addEventListener('scroll', callback);
      callback();
    } else {
      window.removeEventListener('scroll', callback);
    }
  });

  isDesktop.dispatchEvent(new Event('change'));
  callback();
}
